import React from 'react'
import {Button} from "react-bootstrap";

export default function RadioButton({className, value, setSelectedValue, selectedValue, label}) {
    return (
        <Button style={{width: '100px'}} className={className} variant='outline-secondary' active={value === selectedValue} onClick={() => setSelectedValue(value)}>{label}</Button>
    )
}